import React from "react";
import "./DomainAlert.scss";

interface DomainAlertProps {
  domainName?: string;
}

const DomainAlert: React.FC<DomainAlertProps> = ({ domainName }) => {
  const domain = window.location.hostname;
  const domainEnviornment = domain?.includes("us") ? "Prod" : "Dev";

  return (
    <div className="domain-alert">
      <div className="domain-alert-text">
        {`Viewing ${domainName}`} <span> {domainEnviornment} Domain </span>
      </div>
    </div>
  );
};

export default DomainAlert;
